import React from 'react';
import { useSelector } from 'react-redux';
import FormSelect from 'shared/forms/FormSelect';
import { getDocumentTypes } from '../../../slices/documentTypes';

const DocumentTypeDropdown = (props) => {
  const documentTypes = useSelector(getDocumentTypes);
  return (
    <FormSelect
      data={props.data || documentTypes}
      textField="name"
      dataItemKey="id"
      {...props}
    />
  );
};

export default DocumentTypeDropdown;